import {useState} from 'react';
import {BACKEND} from '../lib/api';
export const FOOD_PLACEHOLDER='/images/food-placeholder.svg';
export default function FoodImage({src,alt,...props}){
 const [failed,setFailed]=useState(null);
 const placeholder=!src||failed===src;
 const url=placeholder?FOOD_PLACEHOLDER:src.startsWith('/api')?`${BACKEND}${src}`:src;
 return <img {...props} src={url} alt={placeholder?'Food photo placeholder':alt} onError={()=>{if(!placeholder)setFailed(src);}}/>;
}
